// src/components/printables/PriceLabel.js
import React from 'react';
// Ya no necesitamos Box y Typography de MUI, usaremos etiquetas HTML nativas
// para que sea más ligero y directo.

const PriceLabel = React.forwardRef(({ product }, ref) => {
    if (!product) return null;

    // --- DEFINICIÓN DE ESTILOS EN LÍNEA ---
    const labelStyle = {
        width: '57mm',
        height: '30mm',
        padding: '1mm',
        boxSizing: 'border-box',
        fontFamily: 'Arial, sans-serif',
        color: 'black',
        border: '1px dashed #ccc',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    };

    const nameStyle = {
        height: '25%',
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14pt',
        fontWeight: 'bold',
        lineHeight: 1.1,
        margin: 0,
        padding: 0,
    };

    const priceStyle = {
        height: '60%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderTop: '1px solid #eee',
        borderBottom: '1px solid #eee',
        fontSize: '26pt',
        fontWeight: '900',
        lineHeight: 1,
        margin: 0,
        padding: 0,
    };

    const skuStyle = {
        height: '15%',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        fontSize: '9pt',
        margin: 0,
        padding: 0,
    };

    return (
        <div ref={ref} style={labelStyle}>
            <p style={nameStyle}>
                {product.name}
            </p>
            <p style={priceStyle}>
                {`$${Number(product.sale_price || 0).toFixed(2)}`}
            </p>
            <p style={skuStyle}>
                {product.sku}
            </p>
        </div>
    );
});

export default PriceLabel;